//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


const KNOWN_USERS = {};

export default {

	name: "latte-mini-profile",

	data()
	{
		return {
			el: null,
			user: null,
			isLoading: false
		};
	},

	mounted()
	{
		Latte.action.on("latte:mini-profile:open", ({userId}, el) => this.onMiniProfileRequested(userId, el));
	},

	computed: {

		popup()
		{
			return this.$refs.popup;
		}

	},

	methods: {

		call()
		{
			window.location = `tel:${this.user.phonenumber}`;
		},

		email()
		{
			window.location = `mailto:${this.user.email}`;
		},

		profile()
		{
			window.location = `/admin/user/${this.user.id}`;
		},

		loadUser(id)
		{
			this.isLoading = true;

			if (id in KNOWN_USERS)
			{
				this.onUserLoaded({data: KNOWN_USERS[id]});
			}
			else
			{
				Latte.api.request(`/api/users/${id}`)
					.then(r => r.json())
					.then(r => this.onUserLoaded(r))
					.catch(err => Latte.core.handleError(err));
			}
		},

		onMiniProfileRequested(userId, el)
		{
			this.el = el;
			this.$nextTick(() => this.popup.open());
			this.loadUser(userId);
		},

		onUserLoaded(response)
		{
			this.user = response.data;
			this.isLoading = false;

			KNOWN_USERS[this.user.id] = this.user;
		}

	},

	watch: {}

}

